<template>
    <dialogComponent name="ieAlert" class="modal modal_style4">
        <template v-slot="dialog">
            <div class="fp_modal">
                <div class="cell">
                    <div class="modal_cont">
                        <div class="modal_cont_tips box">
                            <div class="img">
                                <img :src="dialog.logoUrl">
                            </div>
                            <div class="ht10"></div>
                            <div class="text">
                                <h3>贴心提示</h3>
                                <p>为提供最佳的游戏体验，请使用平台建议的浏览器<br>Edge、Firefox、搜狗、Google Chrome！</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </template>
    </dialogComponent>
</template>

<script>
export default {
    name: "IEAlert",
    methods: {
        showDialog() {
            let _ieAlertDialog = this.$dialog.get('ieAlert');
            _ieAlertDialog.show();
        },
    },
}
</script>